module.exports = __webpack_public_path__ + "static/clipboard-caesar-840223265be09128ad682301fdc6a203.svg";